/* registericons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon("devicemanager.discovery", require("./rawicons/discovery.icon.svg.js"));
IconRegistry.registerIcon("devicemanager.discovered", require("./rawicons/discovered.icon.svg.js"));
IconRegistry.registerIcon("devicemanager.api_update", require("./rawicons/api_update.icon.svg.js"));
IconRegistry.registerIcon("devicemanager.cisco_eox", require("./rawicons/cisco_eox.icon.svg.js"));
IconRegistry.registerIcon(
    "devicemanager.cisco_smartnet",
    require("./rawicons/cisco_smartnet.icon.svg.js")
);
IconRegistry.registerIcon(
    "devicemanager.cisco_advisory_list",
    require("./rawicons/cisco_advisory_list.icon.svg.js")
);
IconRegistry.registerIcon(
    "devicemanager.cisco_advisory",
    require("./rawicons/cisco_advisory.icon.svg.js")
);

IconRegistry.registerIcon(
    "devicemanager.network_discovery",
    require("./rawicons/network_discovery.svg")
);

IconRegistry.registerIcon(
    "devicemanager.network_discovery_view",
    require("./rawicons/network_discovery_view.svg")
);

IconRegistry.registerIcon(
    "devicemanager.network_discovery_history",
    require("./rawicons/network_discovery_history.svg")
);

IconRegistry.registerIcon(
    "devicemanager.adhoc_query_view",
    require("./rawicons/adhoc_query.icon.svg")
);

IconRegistry.registerIcon("devicemanager.qualify_cves", require("./rawicons/exposure.icon.svg.js"));

/* Access Status Icons */
IconRegistry.registerIcon(
    "access.unknown",
    require("./rawicons/as_connection_not_attempted.icon.svg")
);

IconRegistry.registerIcon("access.ok", require("./rawicons/as_connected.icon.svg"));
IconRegistry.registerIcon(
    "access.ok_with_white_bg",
    require("./rawicons/as_connected_with_white_bg.icon.svg.js")
);

IconRegistry.registerIcon("access.unreachable", require("./rawicons/as_unreachable.icon.svg"));
IconRegistry.registerIcon(
    "access.unreachable_with_white_bg",
    require("./rawicons/as_unreachable_with_white_bg.icon.svg")
);

IconRegistry.registerIcon(
    "access.invalid_credentials",
    require("./rawicons/as_credential_issue.icon.svg")
);

IconRegistry.registerIcon("access.undiscoverable", require("./rawicons/as_unidentified.icon.svg"));

IconRegistry.registerIcon(
    "devicemanager.offline_discovery_download",
    require("./rawicons/offline_discovery_download.icon.svg.js")
);

IconRegistry.registerIcon(
    "devicemanager.offline_discovery_upload",
    require("./rawicons/offline_discovery_upload.icon.svg.js")
);
